// CloudFront serves index.html for any unmatched path, so an unknown URL lands
// here rather than on an S3 error page.
const NotFound = () => (
  <section>
    <h1>Page not found</h1>
  </section>
)

export default NotFound
